import { combineReducers } from 'redux';

import {
  getVideoMenuListRequest,
  getVideoMenuListFail,
  getVideoMenuListSuccess,
  setVideoMenuListDirty,
  clearVideoMenuList,
} from '../actions';
import { VideoMenuAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { VideoMenu } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<VideoMenu>>;
type ReducerOf<T extends keyof State> = Reducer<State, VideoMenuAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getVideoMenuListRequest.type:
      return state ? stripItems(state) : null;

    case getVideoMenuListSuccess.type:
      return action.payload;

    case clearVideoMenuList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getVideoMenuListRequest.type:
      return true;

    case getVideoMenuListSuccess.type:
    case getVideoMenuListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setVideoMenuListDirty.type:
      return action.payload;

    case getVideoMenuListSuccess.type:
    case getVideoMenuListFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
  dirty,
});
